import React, { useState, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Button, Form, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { SelectTipoHabilitacion } from "./TiposHabilitacion";

/**
 * Boton "+" que da de alta una habilitacion sin salir de la pantalla (p. ej. la
 * partida de una Orden de Compra). Trae el tipo del renglon y el proveedor de la
 * OC; al guardar llama onCreada(habilitacion) para que el renglon la seleccione.
 * El nombre interno se arma como en la carga de costeo: "TIPO · alias/descripcion".
 */
const VACIA = { tipo: "", descripcion: "", alias: "", marca: "", color: "", unidad: "Piezas", costo: "", proveedor: "" };

export function BotonAltaHabilitacion({ tipo, proveedor, onCreada }) {
  const { user } = useContext(AuthContext);
  const [abierto, setAbierto] = useState(false);
  const [datos, setDatos] = useState(VACIA);
  const [guardando, setGuardando] = useState(false);

  // Mismo permiso que la pantalla Nueva Habilitacion.
  if (!user.menu_habilitacion) return null;

  const abrir = () => {
    setDatos({ ...VACIA, tipo: tipo || "", proveedor: proveedor || "" });
    setAbierto(true);
  };
  const cambia = (campo, mayusculas = true) => (e) =>
    setDatos({ ...datos, [campo]: mayusculas ? e.target.value.toUpperCase() : e.target.value });

  const guardar = async (event) => {
    event.preventDefault();
    event.stopPropagation(); // el modal vive dentro del Form de la OC
    setGuardando(true);
    const nombre = `${datos.tipo} · ${(datos.alias || datos.descripcion).trim()}`;
    const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_URL_HABILITACION,
        { ...datos, nombre, descripcion: datos.descripcion.trim(), costo: parseFloat(datos.costo) || 0, observaciones: "NA" },
        headers
      );
      axios.post(process.env.REACT_APP_URL_LOGS, { tipo: "Crear Habilitacion", detalle: nombre, user: user.id }, headers).catch(() => {});
      setAbierto(false);
      onCreada(data);
      Swal.fire({ icon: "success", title: "Habilitación creada", text: nombre, timer: 1500, showConfirmButton: false });
    } catch (error) {
      Swal.fire("No se pudo crear la habilitación", (error.response && error.response.data && error.response.data.message) || "", "error");
    }
    setGuardando(false);
  };

  return (
    <>
      <Button
        type="button"
        color="info"
        size="sm"
        title="Nueva habilitación"
        style={{ marginLeft: 4, flexShrink: 0 }}
        onClick={abrir}
      >
        <i className="fas fa-plus" />
      </Button>
      <Modal size="lg" isOpen={abierto} toggle={() => setAbierto(false)}>
        <Form onSubmit={guardar}>
          <ModalHeader toggle={() => setAbierto(false)}>Nueva habilitación</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={4}>
                <Label>Tipo de habilitación</Label>
                <SelectTipoHabilitacion required value={datos.tipo} onChange={(v) => setDatos({ ...datos, tipo: v })} />
              </Col>
              <Col md={8}>
                <Label>Descripción exacta</Label>
                <Input required value={datos.descripcion} onChange={cambia("descripcion")} placeholder="Ej. BOTÓN MOSTAZA TAPA LISO 24L" />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={4}>
                <Label>Alias (como lo conocen)</Label>
                <Input value={datos.alias} onChange={cambia("alias", false)} />
              </Col>
              <Col md={4}>
                <Label>Marca</Label>
                <Input value={datos.marca} onChange={cambia("marca")} />
              </Col>
              <Col md={4}>
                <Label>Color</Label>
                <Input value={datos.color} onChange={cambia("color")} />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={4}>
                <Label>Unidad</Label>
                <Input type="select" required value={datos.unidad} onChange={cambia("unidad", false)}>
                  <option value="Piezas">Piezas</option>
                  <option value="Metros">Metros</option>
                  <option value="Kilos">Kilos</option>
                </Input>
              </Col>
              <Col md={4}>
                <Label>Costo</Label>
                <Input type="number" step="any" min="0" required value={datos.costo} onChange={cambia("costo", false)} />
              </Col>
              <Col md={4}>
                <Label>Proveedor</Label>
                <Input value={datos.proveedor} onChange={cambia("proveedor")} />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" onClick={() => setAbierto(false)}>
              Cancelar
            </Button>
            <Button type="submit" color="success" disabled={guardando}>
              <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </>
  );
}
